import { IAnalyticsConfiguration } from '../../../../../domain/analytics/analytics-configuration'
import { IPageConfiguration } from '../../../../../domain/conf/page'
import { DefaultAnalyticsFormatter } from '../../../../analytics/formatters/default'
import { AnalyticsMetaKeys as key } from '../../../../analytics/formatters/meta-keys'

/**
 * Klangoo helper functions.
 */
export const KruxUtils = {
    /**
     * Reads original conf object and generate a smaller object for Krux
     *
     * @param {object} conf
     * @returns {object}
     */

    formatData(pageConf?: IPageConfiguration, analyticsConf?: IAnalyticsConfiguration): object {
        const formatter = new DefaultAnalyticsFormatter()
        const obj: any = {}

        if (analyticsConf) {
            obj[key.VENDOR] = analyticsConf.vendor
            obj[key.BRAND] = analyticsConf.brand
            obj[key.DIVISION] = analyticsConf.division
        }

        if (pageConf) {
            obj[key.DISTRIBUTOR] = pageConf.dist
            obj[key.TYPE] = pageConf.type
            if (pageConf.tags) {
                obj[key.TAG] = pageConf.tags.join(', ')
            }

            if (pageConf.captureUrlParams && pageConf.captureUrlParams.length > 0) {
                const urlSearchParams = new URLSearchParams(window.location.search)

                obj[key.URL_PARAMS] = {}
                pageConf.captureUrlParams.forEach((p: string) => {
                    obj[key.URL_PARAMS][p] = urlSearchParams.get(p)
                })
            }

            if (pageConf.type === 'story') {
                if (pageConf.writers && pageConf.writers.main && pageConf.writers.main.length > 0) {
                    obj[key.WRITERS] = pageConf.writers.main.map(
                        (_: any) => typeof _ === 'object' ? _.name : _
                    ).join(', ')
                }
                obj[key.ARTICLE_ID] = pageConf.articleId
                obj[key.FORMAT] = 'HTML'

                return {
                    ...obj,
                    ...formatter.title(pageConf.title),
                    ...formatter.klangoo(pageConf.klangoo)
                }
            }
        }

        return obj
    }
}
